<template>
  <div class="d-flex">
    <StatusChip
      data-tourid="finding-status-chip"
      :status="status"
      :statusText="statusText"
      :availableStatus="availableStatus"
      :isEditable="canEdit"
      :large="large"
      :textClass="textClass"
      :color="color"
      @onChange="handleSelectStatus"
    />
  </div>
</template>
<script>
import _ from 'lodash'
import StatusChip from '../Core/StatusChip.vue'

export default {
  name: 'FindingStatus',

  components: {
    StatusChip,
  },

  props: {
    status: {
      type: String,
      required: true,
    },
    canEdit: {
      type: Boolean,
      required: false,
      default: false,
    },
    large: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  computed: {
    statusText() {
      return this.getStatusText(this.status)
    },

    findingStatus() {
      return this.$constants.findings.status
    },

    isInReviewStatusEnabled() {
      return this.$isFeatureEnabled(this.$featuresKeys.inReviewStatus)
    },

    availableStatus() {
      return _.compact([
        {
          value: this.findingStatus.open,
          text: this.getStatusText(this.findingStatus.open),
        },
        {
          value: this.findingStatus.inProgress,
          text: this.getStatusText(this.findingStatus.inProgress),
        },
        {
          value: this.findingStatus.completed,
          text: this.getStatusText(this.findingStatus.completed),
        },
        this.isInReviewStatusEnabled
          ? {
              value: this.findingStatus.inReview,
              text: this.getStatusText(this.findingStatus.inReview),
            }
          : null,

        {
          value: this.findingStatus.onHold,
          text: this.getStatusText(this.findingStatus.onHold),
        },
        {
          value: this.findingStatus.canceled,
          text: this.getStatusText(this.findingStatus.canceled),
        },
      ])
    },
    color() {
      switch (this.status) {
        case this.findingStatus.open:
          return 'teal lighten-2'
        case this.findingStatus.inProgress:
          return 'blue lighten-2'
        case this.findingStatus.canceled:
          return 'blue-grey darken-2'
        case this.findingStatus.inReview:
          return 'blue-grey lighten-2'
        case this.findingStatus.onHold:
          return 'yellow lighten-2'
        case this.findingStatus.completed:
          return 'green lighten-2'
        default:
          return ''
      }
    },
    textClass() {
      switch (this.status) {
        case this.findingStatus.open:
          return 'teal--text text--darken-2'
        case this.findingStatus.inProgress:
          return 'blue--text text--darken-1'
        case this.findingStatus.canceled:
          return 'blue-grey--text text--lighten-3'
        case this.findingStatus.completed:
          return 'green--text text--darken-1'
        case this.findingStatus.inReview:
          return 'blue-grey--text text--darken-3'
        case this.findingStatus.onHold:
          return 'yellow--text text--darken-1'
        default:
          return ''
      }
    },
  },
  methods: {
    getStatusText(status) {
      return this.$t(
        `routines.findings_status.${this.getStatusTranslationKey(status)}`
      )
    },
    getStatusTranslationKey(status) {
      return _.snakeCase(status)
    },
    handleSelectStatus(status) {
      this.$emit('onChange', status)
    },
  },
}
</script>
